import { Injectable } from '@angular/core';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

@Injectable({
  providedIn: 'root'
})
export class SecureStorageService {

  private readonly STORAGE_PREFIX = 'secure_';

  /* =========================
     Set
     ========================= */

  async set<T>(key: string, value: T): Promise<void> {
    await SecureStoragePlugin.set({
      key: this.buildKey(key),
      value: JSON.stringify(value)
    });
  }

  /* =========================
     Get
     ========================= */

  async get<T>(key: string, defaultValue?: any): Promise<T | null> {
    try {
      const result = await SecureStoragePlugin.get({
        key: this.buildKey(key)
      });

      return result?.value
        ? JSON.parse(result.value) as T
        : defaultValue;
    } catch {
      return null;
    }
  }

  /* =========================
     Remove
     ========================= */

  async removeItem(key: string): Promise<void> {
    await SecureStoragePlugin.remove({
      key: this.buildKey(key)
    });
  }

  /* =========================
     Clear (keys connues)
     ========================= */

  async clear(keys: string[]): Promise<void> {
    await Promise.all(
      keys.map(key => this.removeItem(key))
    );
  }

  /* =========================
     Utils
     ========================= */

  private buildKey(key: string): string {
    return `${this.STORAGE_PREFIX}${key}`;
  }
}
